/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierProBlockDetail } from "./CarrierProBlockDetail";
import {
  CarrierProBlockDetailFromJSON,
  CarrierProBlockDetailFromJSONTyped,
  CarrierProBlockDetailToJSON,
  CarrierProBlockDetailToJSONTyped,
} from "./CarrierProBlockDetail";

/**
 *
 * @export
 * @interface CarrierProBlockSummary
 */
export interface CarrierProBlockSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockSummary
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockSummary
   */
  carrierAccountNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockSummary
   */
  shipmentsPerMonth: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockSummary
   */
  remaining: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockSummary
   */
  monthsLeft?: number | null;
  /**
   *
   * @type {Array<CarrierProBlockDetail>}
   * @memberof CarrierProBlockSummary
   */
  blocks: Array<CarrierProBlockDetail>;
}

/**
 * Check if a given object implements the CarrierProBlockSummary interface.
 */
export function instanceOfCarrierProBlockSummary(
  value: object,
): value is CarrierProBlockSummary {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("shipmentsPerMonth" in value) ||
    value["shipmentsPerMonth"] === undefined
  )
    return false;
  if (!("remaining" in value) || value["remaining"] === undefined) return false;
  if (!("blocks" in value) || value["blocks"] === undefined) return false;
  return true;
}

export function CarrierProBlockSummaryFromJSON(
  json: any,
): CarrierProBlockSummary {
  return CarrierProBlockSummaryFromJSONTyped(json, false);
}

export function CarrierProBlockSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProBlockSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    carrierAccountNumber:
      json["carrierAccountNumber"] == null
        ? undefined
        : json["carrierAccountNumber"],
    shipmentsPerMonth: json["shipmentsPerMonth"],
    remaining: json["remaining"],
    monthsLeft: json["monthsLeft"] == null ? undefined : json["monthsLeft"],
    blocks: (json["blocks"] as Array<any>).map(CarrierProBlockDetailFromJSON),
  };
}

export function CarrierProBlockSummaryToJSON(
  json: any,
): CarrierProBlockSummary {
  return CarrierProBlockSummaryToJSONTyped(json, false);
}

export function CarrierProBlockSummaryToJSONTyped(
  value?: CarrierProBlockSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    carrierAccountNumber: value["carrierAccountNumber"],
    shipmentsPerMonth: value["shipmentsPerMonth"],
    remaining: value["remaining"],
    monthsLeft: value["monthsLeft"],
    blocks: (value["blocks"] as Array<any>).map(CarrierProBlockDetailToJSON),
  };
}
